export default __webpack_public_path__ + "static/media/Grey_finished.50f9498e.jpg";